import { render, staticRenderFns } from "./FieldRutDisplay.vue?vue&type=template&id=c2791788&scoped=true&lang=pug"
import script from "./FieldRutDisplay.vue?vue&type=script&lang=js"
export * from "./FieldRutDisplay.vue?vue&type=script&lang=js"
import style0 from "./FieldRutDisplay.vue?vue&type=style&index=0&id=c2791788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2791788",
  null
  
)

export default component.exports